import { useEffect } from "react";
import { useThemeColor } from "@/hooks/useThemeColor";

export function ThemeColorProvider({ children }: { children: React.ReactNode }) {
  const { themeColor } = useThemeColor();

  // Theme color is automatically applied by the useThemeColor hook
  return <>{children}</>;
}
